import { sharedConfig } from '@/pageConfig/shared';
import { DocumentTypes } from 'contentlayer/generated';
import content from '../../../../.contentlayer/generated/Accessibility/accessibility__en-NL.mdx.json';
import type { BasePageConfig } from '../../BasePageConfig';
export type Config = BasePageConfig;
export const config: Config = {
  layout: { ...sharedConfig['en-NL'].layout },
  seo: {
    title: 'Commitment To We Accessibility | Lemonade',
    metaTitle: 'Commitment To Web Accessibility | Lemonade',
    description:
      'Lemonade is committed to making our website’s content accessible and user-friendly to everyone. We take your feedback seriously as we evaluate ways to accommodate all of our customers and our overall accessibility policies. We strongly encourage vendors of third-party digital content to provide content that is accessible and user-friendly.',
    ogImage: sharedConfig['en-NL'].seo.ogImage,
  },
  MDXContent: content as DocumentTypes,
};
